import React from "react";

const IconSettingsFilled = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M13.18 3h-2.36l-.435 2.174-.556.18a6.972 6.972 0 0 0-2.506 1.44l-.435.392-2.092-.708-1.18 2.044L5.274 9.98l-.12.572c-.201.95-.197 1.932.005 2.891l.121.572-1.664 1.463 1.18 2.044 2.09-.706.435.39a7.033 7.033 0 0 0 2.511 1.45l.555.181L10.82 21h2.36l.435-2.174.556-.18a6.972 6.972 0 0 0 2.506-1.44l.435-.392 2.092.708 1.18-2.044-1.658-1.458.12-.572c.201-.95.197-1.932-.005-2.891l-.121-.572 1.664-1.463-1.18-2.044-2.09.706-.435-.39a7.033 7.033 0 0 0-2.511-1.45l-.555-.181L13.18 3zm2.283 11a4 4 0 1 1-6.927-4 4 4 0 0 1 6.927 4z"
        stroke="currentColor"
        strokeWidth={2}
        fill="currentColor"
      />
    </g>
  </svg>
);

export default IconSettingsFilled;
